import {
  SET_BEHANDLUNG,
  SET_PRAXIS,
  SET_BEHANDLER,
  SET_SELECTED_DAY,
  SET_SELECTED_ROW,
  SET_SELECTED_TERMIN,
  SET_KOSTENUEBERNAHME,
  SET_KOSTENUEBERNAHME_FINAL,
  SET_BEHANDLERAUSWAHL_UEBERSPRUNGEN,
  SET_BEHANDLUNGSART,
  SET_ACTUAL_TERMIN,
  SET_PATIENT,
  SET_SELECTED_PROPOSALS
} from "./mutations.type";

import praxenClinius from "../static/praxen.clinius";
import praxenCliniusCh from "../static/praxen.cliniusCh";

export default {
  namespaced: true,
  state: {
    /**
     * Direkte Behandlungsart mit ID usw.
     */
    behandlung: null,

    /**
     * Übergeordnete Behandlungsart bei Clinius
     */
    behandlungsart: null,
    praxis: process.env.VUE_APP_CLINIUS_CH==="1"? praxenCliniusCh[0] : praxenClinius[0],
    behandler: null,
    selectedTermin: null,
    actualTermin: null,
    selectedDay: null,
    selectedRow: null,
    selectedProposals: null,
    kostenuebernahme: null,
    kostenuebernahme_final: false,
    behandlerauswahlUebersprungen: false,
    patient: null
  },
  mutations: {
    [SET_BEHANDLUNG](state, data) {
      state.behandlung = data;
    },
    [SET_PRAXIS](state, data) {
      state.praxis = data;
    },
    [SET_BEHANDLER](state, data) {
      state.behandler = data;
    },
    [SET_SELECTED_DAY](state, data) {
      state.selectedDay = data;
    },
    [SET_SELECTED_ROW](state, data) {
      state.selectedRow = data;
    },
    [SET_SELECTED_PROPOSALS](state, data) {
      state.selectedProposals = data;
    },
    [SET_SELECTED_TERMIN](state, data) {
      state.selectedTermin = data;
    },
    [SET_ACTUAL_TERMIN](state, data) {
      state.actualTermin = data;
    },
    [SET_KOSTENUEBERNAHME](state, data) {
      state.kostenuebernahme = data;
    },
    [SET_KOSTENUEBERNAHME_FINAL](state,val) {
      state.kostenuebernahme_final = val;
    },
    [SET_BEHANDLERAUSWAHL_UEBERSPRUNGEN](state, data) {
      state.behandlerauswahlUebersprungen = data;
    },
    [SET_BEHANDLUNGSART](state, data) {
      state.behandlungsart = data;
    },
    [SET_PATIENT](state, data) {
      state.patient = data;
    }
  },
  actions: {
    clear({ commit, state }) {
      commit(SET_BEHANDLUNG, null);
      commit(SET_BEHANDLUNGSART, null);

      if(!state.kostenuebernahme_final)
        commit(SET_KOSTENUEBERNAHME, null);

      commit(SET_PRAXIS, null);
      commit(SET_BEHANDLER, null);
      commit(SET_SELECTED_DAY, null);
      commit(SET_SELECTED_ROW, null);
      commit(SET_SELECTED_TERMIN, null);
      commit(SET_BEHANDLERAUSWAHL_UEBERSPRUNGEN, false);
    },
    clearSelectedTermin({ commit}) {
      commit(SET_SELECTED_DAY, null);
      commit(SET_SELECTED_ROW, null);
      commit(SET_SELECTED_TERMIN, null);
      commit(SET_BEHANDLERAUSWAHL_UEBERSPRUNGEN, false);
    }
  }
}
